module.exports = __webpack_public_path__ + "img/stop-8.87b4a5b5.jpg";